import React from "react";
import Cropper from "react-easy-crop";
import { Loader2 } from "lucide-react";

// Purely presentational "reposition + zoom" step, rendered inline inside the
// avatar EditSectionDrawer body (state/logic lives in useAvatarCropper).
export function AvatarCropView({ cropper, t }) {
  return (
    <div className="flex flex-col gap-3">
      <div className="relative w-full rounded-2xl overflow-hidden bg-black" style={{ height: 260 }} data-testid="avatar-crop-area">
        {cropper.imageSrc ? (
          <Cropper
            image={cropper.imageSrc}
            crop={cropper.crop}
            zoom={cropper.zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={cropper.setCrop}
            onZoomChange={cropper.setZoom}
            onCropComplete={cropper.onCropComplete}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            {cropper.loadError ? (
              <p className="text-white text-xs font-poppins px-4 text-center" data-testid="avatar-crop-error">{t("profTab.avatarInvalidType")}</p>
            ) : (
              <Loader2 className="h-6 w-6 text-white animate-spin" />
            )}
          </div>
        )}
      </div>
      <input type="range" min={1} max={3} step={0.01} value={cropper.zoom} data-testid="avatar-crop-zoom-slider"
        onChange={(e) => cropper.setZoom(Number(e.target.value))} className="w-full accent-[#028CF8]" />
    </div>
  );
}
